module.exports = __webpack_public_path__ + "static/media/uit2.c358563b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/uit2.jpg
// module id = 5807
// module chunks = 0